import React, { Component } from "react";
import { connect } from "react-redux";
import { makeStyles } from "@material-ui/core/styles";

import { NAME } from "./constants";
import { TextField, Grid, Button, Fab, Tooltip } from "@material-ui/core";

import CircularProgress from "@material-ui/core/CircularProgress";
import UserSectionTopbar from "../../components/access/UserAccessTopBar";
import Session from "../../utils/Session";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { QRCode } from "react-qr-svg";
import { getQRCode } from "./actions";
import { Base64 } from 'js-base64';
import ExitToApp from "@material-ui/icons/ExitToApp";


const useStyles = makeStyles((theme) => ({
  root: {
    marginTop: "45px",
  },
  spinnerContainer: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    width: "100%",
    height: "100vh",
  },
  container: {
    marginTop: 50,
  },
  topAnimation: {
    width: "100%",
    left: 0,
    top: 0,
    position: "absolute",
  },
  cssFocused: {
    color: "#000!imporntat",
  },
  cssLabel: {
    color: "#000!important",
  },
  cssOutlinedInput: {
    color: "#000!important",
    borderColor: "#000!important",
  },
  notchedOutline: {
    color: "#000!important",
    borderColor: "#000!important",
  },
  textContainer: {
    paddingLeft: 20,
    paddingRight: 20,
    marginTop: 20,
    height: 30,
  },
  textField: {
    marginTop: 30,
    textAlign: "center",
    width: "100%",
    background: "#fafafc",
  },
  updateButton: {
    marginTop: 30,
    alignItems: "center",
    width: "100%",
    height: 50,
    backgroundColor: "#def2fb",
    color: "#55c9f4",
    fontWeight: "bold!important",
    textTransform: "capitalize!important",
    "&:hover": {
      cursor: "pointer",
      backgroundColor: "#55c9f4!important",
      color: "#ffffff!important",
    },
  },
  qrContainer: {
    width: "100%",
    padding: "0px!important",
    display: "flex",
    alignItems: "center",
    justifyContent: "center"
  },
  qrStyle: {
    width: 256,
    marginBottom: 60,
    alignSelf: "center"
  },
  spinnerStyle: {
    color: "#55c9f4",
  },
  fab: {
    backgroundColor: "#55c9f4",
    position: "absolute",
    bottom: theme.spacing(2),
    right: theme.spacing(2),
    color: "#ffffff",
    "&:hover": {
      alfa: "0.4",
      backgroundColor: "#55c9f4",
      color: "#ffffff",
    },
  },
}));


const ControlPointSection = ({
  controlPointId,
  getQRCode,
  qrcode,
  isLoading,
}) => {
  const classes = useStyles();
  const [token, setControlPointToken] = React.useState("");
  const [newQRCode, setQRCode] = React.useState(null);
  const [dummyState, setDummyState] = React.useState(null);

  React.useEffect(() => {
    // Request QR code at startup
    if (Session.getAccessCode()) {
      getQRCode(controlPointId, handleOnSuccess, handleOnError);
    }
  }, []);

  React.useEffect(() => {
    if (qrcode) {
      setQRCode(qrcode);
    }
  }, [qrcode]);

  function refreshQRCode() {
    // Request the QR Code every 60 seconds
    setTimeout(() => {
      getQRCode(controlPointId, handleOnSuccess, handleOnError);
    }, 60000);
  }

  function handleOnSuccess(data) {
    if (!Session.getAccessCode()) {
      Session.setAccessCode(token);
    }

    // Refresh the QR Code 
    refreshQRCode();
  }

  function handleOnError(error, reason) {
    if (reason !== null && reason == "INVALID_TOKEN") {
      // The control point code has changed, that means that we need
      // to take the user to the previous screen
      toast.error(error);
      onLogoutCP();
      return;
    }

    // There's no CP token stored (is loged out)
    if (!Session.getAccessCode()) {
      toast.error(error);
      return;
    }

    refreshQRCode();
  }

  function onLogoutCP() {
    Session.clearAccessCode();
    setDummyState(new Date());
  }

  function onLoginCP() {
    Session.setAccessCode(token);
    getQRCode(controlPointId, handleOnSuccess, handleOnError)
  }

  return (
    <div className={classes.root}>
      <ToastContainer hideProgressBar={true}></ToastContainer>
      <div>
        <UserSectionTopbar />
        <Grid container>
          <Grid item xs={1} sm={3} md={4} />
          <Grid item xs={10} sm={6} md={4}>
            {!Session.getAccessCode() ? (
              <TextField
                required
                id="password"
                label="Control Point Password"
                type="password"
                autoComplete="password"
                className={classes.textField}
                variant="outlined"
                onChange={(e) => {
                  setControlPointToken(e.target.value);
                }}
                InputLabelProps={{
                  classes: {
                    root: classes.cssLabel,
                    focused: classes.cssFocused,
                  },
                }}
                InputProps={{
                  classes: {
                    root: classes.cssOutlinedInput,
                    focused: classes.cssFocused,
                    notchedOutline: classes.notchedOutline,
                  },
                }}
              />
            ) : (
              <div></div>
            )}
          </Grid>
          <Grid item xs={1} sm={3} md={4} />
        </Grid>
        <Grid container>
          <Grid item xs={1} sm={3} md={4} />
          <Grid item xs={10} sm={6} md={4}>
            {!Session.getAccessCode() ? (
              <Button
                className={classes.updateButton}
                onClick={onLoginCP}
              >
                Ingresar
              </Button>
            ) : (
              <div></div>
            )}
          </Grid>
          <Grid item xs={1} sm={3} md={4} />
        </Grid>
        {
          Session.getAccessCode() ?
            <Grid container className={classes.container}>
              <Grid item xs={12} md={12} style={{ position: "relative", heigh: 300 }} className={classes.qrContainer}>
                <div style={{ position: "absolute", top: 0 }}>
                  {
                    newQRCode ? <QRCode
                      id="qr-code"
                      bgColor="#FFFFFF"
                      fgColor="#000000"
                      level="Q"
                      className={classes.qrStyle}
                      value={newQRCode}
                    /> : <></>
                  }
                </div>

                <div>
                  {
                    isLoading ? <CircularProgress style={{ marginTop: 110 }} className={classes.spinnerStyle} /> : <></>
                  }
                </div>
              </Grid>
            </Grid> : <></>
        }

      </div>
      <Tooltip title="Logout" placement="left">
        <Fab
          color="primary"
          aria-label="Logout"
          className={classes.fab}
          onClick={onLogoutCP}
        >
          <ExitToApp />
        </Fab>
      </Tooltip>
    </div>
  );
};

class ControlPointDynamicPortal extends Component {
  componentWillMount() {
    document.body.style.background = "#ffffff";
  }

  componentDidMount() {
    this.createManifest();
  }

  // This function creates a dinamyc manifest.json that allows a PWA app.
  // When the app is saved into the desktop on a mobile device it use this new manifest.json
  // to create teh PWA app using the Key start URL
  createManifest() {
    var myDynamicManifest = {
      short_name: "Cittyo control",
      name: "Cittyo control point.",
      icons: [
        {
          src: "icon.png",
          sizes: "64x64 32x32 24x24 16x16",
          type: "image/x-icon",
        },
        {
          src: "logo192.png",
          type: "image/png",
          sizes: "192x192",
        },
        {
          src: "logo512.png",
          type: "image/png",
          sizes: "512x512",
        },
      ],
      start_url: this.props.location.pathname,
      display: "standalone",
      theme_color: "#000000",
      background_color: "#ffffff",
    };

    const stringManifest = JSON.stringify(myDynamicManifest);
    const blob = new Blob([stringManifest], { type: "application/json" });
    const manifestURL = URL.createObjectURL(blob);
    document
      .querySelector("#my-manifest-placeholder")
      .setAttribute("href", manifestURL);
  }

  getLinkParameters() {
    var pathParams = this.props.location.pathname.split("/");
    if (pathParams.length >= 1 && pathParams[1] === "cp") {
      return {
        controlPointId: Base64.decode(pathParams[2]),
      };
    }

    return undefined;
  }

  render() {
    const params = this.getLinkParameters();
    return (
      <ControlPointSection
        controlPointId={params.controlPointId}
        qrcode={this.props.qrcode}
        isLoading={this.props.isLoading}
        getQRCode={this.props.getQRCode} />
    );
  }
}

function mapStateToProps(state) {
  return {
    error: state[NAME].error,
    isLoading: state[NAME].isLoading,
    qrcode: state[NAME].qrcode,
  };
}

function mapDispatchToProps(dispatch) {
  return {
    getQRCode: (controlPointId, handleOnSuccess, handleOnError) =>
      dispatch(getQRCode(controlPointId, handleOnSuccess, handleOnError)),
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(ControlPointDynamicPortal);
